module.exports = __webpack_public_path__ + "img/logo.a9d7afd2.png";